// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"ResponsiveTable_tableContainer__2dV6w","gridContainer":"ResponsiveTable_gridContainer__2lIW2"};